module.exports = {
      id: "chevron-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.bfe893b5.svg#chevron-usage",
      toString: function () {
        return this.url;
      }
    }